import { render } from "./Index.vue?vue&type=template&id=ba49afbc"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Auth/Register/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba49afbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba49afbc', __exports__)) {
    api.reload('ba49afbc', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=ba49afbc", () => {
    api.rerender('ba49afbc', render)
  })

}


export default __exports__